import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate(user.has_paid ? '/dashboard' : '/betalning');
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const userData = await login(email, password);
      navigate(userData.has_paid ? '/dashboard' : '/betalning');
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <a href="/" className="heading-font text-2xl font-medium text-[#0A0A0A]">Emotionell Frihet™</a>
        </div>
        
        <div className="bg-[#FEFCFA] rounded-2xl p-8 border border-[#E8E0DB]">
          <h1 className="heading-font text-2xl font-medium text-[#0A0A0A] mb-6 text-center">Logga in</h1>
          
          {error && <p className="text-red-600 text-sm mb-4 text-center">{error}</p>}
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="email"
              placeholder="E-post"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="rounded-xl"
            />
            <Input
              type="password"
              placeholder="Lösenord"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="rounded-xl"
            />
            <Button 
              type="submit" 
              disabled={loading}
              className="w-full bg-[#A0655A] hover:bg-[#8B5549] text-white rounded-full py-6"
            >
              {loading ? 'Loggar in...' : 'Logga in'}
            </Button>
          </form>
          
          <p className="text-center text-sm text-[#111111] mt-6">
            Har du inget konto? <a href="/registrera" className="text-[#A0655A] hover:underline">Registrera dig</a>
          </p>
        </div>

        <div className="text-center mt-6">
          <a href="/" className="text-sm text-[#A0655A] hover:underline flex items-center justify-center gap-1">
            <ChevronLeft size={16} /> Tillbaka till startsidan
          </a>
        </div>
      </div>
    </div>
  );
}
